import { formatInTimeZone } from 'date-fns-tz';
import { addMinutes } from 'date-fns';

export const getFormattedDateString = (startTime: string) => {
  const startTimeFormatted =
    [
      formatInTimeZone(new Date(startTime), 'UTC', 'yyyyMMdd'),
      formatInTimeZone(new Date(startTime), 'UTC', 'HHmmss'),
    ].join('T') + 'Z';

  const endTime = addMinutes(new Date(startTime), 30);
  const endTimeFormatted =
    [formatInTimeZone(endTime, 'UTC', 'yyyyMMdd'), formatInTimeZone(endTime, 'UTC', 'HHmmss')].join(
      'T',
    ) + 'Z';
  return `${startTimeFormatted}/${endTimeFormatted}`;
};
